import { useTranslation } from "react-i18next";
import ExamActions from "src/components/NewComponents/Views/Actions/ExamActions";

interface BlockedActionsProps {
	lesson: any;
}

export const BlockedActions = ({ lesson }: BlockedActionsProps) => {
	const { t } = useTranslation();

	return (
		<ExamActions
			row={{ status: lesson?.status }}
			onPrimary={() => null}
			primaryText={t("commands.blocked")}
		/>
	);
};
